import React from 'react'
import { connect } from 'react-redux'
import { RootState } from '../../../../store/rootState'
import { IProject } from '../../types/project'
import { ContentHeader } from '../../../../components/Header/ContentHeader'

interface Props {
  project: IProject
}

const InvoiceListHeaderContainer = (props: Props): JSX.Element | null=> {

  const { project } = props

  if (project) {
    return (
      <ContentHeader
        id='projectActivitiesHeader'
        title={project.name}
        color='#08D6A1'
        backTitle='Accounting'
        subtitle={project.customer?.name ?? project.category}
        backLocation={`/projects/${project.id}/accounting`}
        column={true}
      />
    )
  }
  return null
}

const mapStateToProps = (state: RootState): Props => {
  return {
    project: state.projectsState.project
  }
}

export default connect(mapStateToProps, null)(InvoiceListHeaderContainer)
